import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogRef } from '@shared/components/ui/dynamic-dialog/dynamic-dialog-ref';
import { DynamicDialogConfig } from '@shared/components/ui/dynamic-dialog/dynamic-dialog.component';
import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { InputDialogData } from '../../services/dialog.service';

@Component({
  selector: 'app-input-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    ButtonComponent
  ],
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent {
  inputControl: FormControl;
  data: InputDialogData;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.data = config.data as InputDialogData;
    const validators = [];

    if (this.data.required) {
      validators.push(Validators.required);
    }

    if (this.data.minLength) {
      validators.push(Validators.minLength(this.data.minLength));
    }

    if (this.data.maxLength) {
      validators.push(Validators.maxLength(this.data.maxLength));
    }

    if (this.data.pattern) {
      validators.push(Validators.pattern(this.data.pattern));
    }

    this.inputControl = new FormControl(this.data.defaultValue || '', validators);
  }

  onConfirm(): void {
    if (this.inputControl.valid) {
      this.dialogRef.close(this.inputControl.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
